(function () {
  'use strict';

  var grid = document.getElementById('products-grid');
  if (!grid) return;

  var announcer = document.getElementById('collection-infinite-announcer');
  var loadingMsg = grid.getAttribute('data-ann-loading') || 'Loading more products';
  var loadedMsg = grid.getAttribute('data-ann-loaded') || 'More products loaded';
  var errorMsg = grid.getAttribute('data-ann-error') || 'Could not load more products';

  var loading = false;
  var observer;

  function announce(text) {
    if (!announcer) return;
    announcer.textContent = '';
    setTimeout(function () {
      announcer.textContent = text;
    }, 50);
  }

  function setBusy(isBusy) {
    grid.setAttribute('aria-busy', isBusy ? 'true' : 'false');
    var loaderEl = grid.querySelector('.collection__loader');
    if (loaderEl) {
      loaderEl.setAttribute('aria-busy', isBusy ? 'true' : 'false');
      var hint = loaderEl.querySelector('[data-loader-text]');
      if (hint) {
        hint.textContent = isBusy ? loadingMsg : '';
      }
    }
  }

  function parseFragment(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var tpl = doc.querySelector('template[data-infinite-scroll-parse-root]');
    if (!tpl || !tpl.content) return [];
    return Array.prototype.slice.call(tpl.content.children);
  }

  function disconnectObserver() {
    if (observer) {
      observer.disconnect();
      observer = null;
    }
  }

  function observeLoader(loader) {
    disconnectObserver();
    if (!loader) return;
    var nextUrl = loader.getAttribute('data-next-page');
    if (!nextUrl) return;

    observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          loadNext(loader);
        });
      },
      { rootMargin: '200px 0px', threshold: 0 }
    );
    observer.observe(loader);
  }

  function loadNext(loader) {
    var url = loader.getAttribute('data-next-page');
    if (!url || loading) return;

    loading = true;
    disconnectObserver();

    setBusy(true);
    announce(loadingMsg);

    fetch(url, { credentials: 'same-origin' })
      .then(function (res) {
        if (!res.ok) throw new Error('Network error');
        return res.text();
      })
      .then(function (html) {
        var nodes = parseFragment(html);
        if (!nodes.length) throw new Error('Empty fragment');

        var loaderItem = grid.querySelector('.collection__loader-item');
        if (!loaderItem) throw new Error('Missing loader slot');

        var newLoaderLi = null;
        nodes.forEach(function (node) {
          if (node.classList && node.classList.contains('collection__loader-item')) {
            newLoaderLi = node;
          } else {
            grid.insertBefore(node, loaderItem);
          }
        });

        if (newLoaderLi) {
          loaderItem.replaceWith(newLoaderLi);
        } else {
          loaderItem.remove();
        }

        document.dispatchEvent(new CustomEvent('CollectionUpdate'));

        var nextLoader = grid.querySelector('.collection__loader');
        if (nextLoader && nextLoader.getAttribute('data-next-page')) {
          observeLoader(nextLoader);
        }

        setBusy(false);
        announce(loadedMsg);
      })
      .catch(function () {
        setBusy(false);
        announce(errorMsg);
        var retryLoader = grid.querySelector('.collection__loader');
        if (retryLoader) observeLoader(retryLoader);
      })
      .finally(function () {
        loading = false;
      });
  }

  var initialLoader = grid.querySelector('.collection__loader');
  if (initialLoader) {
    observeLoader(initialLoader);
  }
})();
